/**
 * Clone the host document's styles into a same-origin frame.
 *
 * Two callers need a frame whose cascade matches the host exactly:
 * `ViewportFrame` (visible previews at a fixed viewport) and the Foundations
 * token helpers (hidden frames used to resolve responsive tokens at both
 * breakpoints). Copying `data-brand` is part of the contract — the frame gets
 * its own `<html>`, so without it every brand-scoped token falls back to CLS.
 */
const syncStyles = (frameDoc) => {
  const head = frameDoc.head;
  head.querySelectorAll('[data-ds-synced]').forEach((el) => el.remove());

  document.querySelectorAll('style, link[rel="stylesheet"]').forEach((node) => {
    const clone = node.cloneNode(true);
    clone.setAttribute('data-ds-synced', '');
    head.appendChild(clone);
  });

  const brand = document.documentElement.getAttribute('data-brand');
  if (brand) frameDoc.documentElement.setAttribute('data-brand', brand);
};

export default syncStyles;
